import { GET_COURIERS } from "constants/couriers";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_COURIERS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
